/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Функция для склонения русских слов
 *
 * @author Nikolay Sviridov
 * @version 1.35.0
 * @since 1.35.0
 */

/**
 * Пример использования: declinationWholeWord(4, 'день', 'дня', 'дней')
 *
 * @param      {number}  number Число, для которого будет подставлено слово
 * @param      {string}  one    Слово для одного (день)
 * @param      {string}  two    Слово от двух до четырех (дня)
 * @param      {string}  five   Слово от пяти до десяти (дней)
 * @return     {string}  Слово в соответсвии с числом (1 день, 4 дня, 9 дней)
 */
const declinationWholeWord = (number: number, one: string, two: string, five: string): string => {
	let n = Math.abs(number);
	n %= 100;
	if (n >= 5 && n <= 20) {
		return five;
	}
	n %= 10;
	if (n === 1) {
		return one;
	}
	if (n >= 2 && n <= 4) {
		return two;
	}
	return five;
};

export default declinationWholeWord;
